<div class="row error-detail" *ngIf="showErrDetail">
  <div class="col-6">serverCode: {{dataErr.codeError }} </div>
  <div class="col-6 text-right">wsCode : {{dataErr.wsName}}</div>
  <div class="col-6 offset-6  text-right" *ngIf="dataErr?.codeError == 409 ">fiableCode: {{dataErr?.codeFiable }} </div>
</div>
<div class="row">
  <div class="col-12 text-center">
    <div class="symbol-alert-icon symbol-alert-error animate" *ngIf="typeOfAlert === 'error'">
      <span class="symbol-alert-x-mark">
        <span class="symbol-alert-line symbol-alert-left animateXLeft"></span>
        <span class="symbol-alert-line symbol-alert-right animateXRight"></span>
      </span>
      <div class="symbol-alert-placeholder"></div>
      <div class="symbol-alert-fix"></div>
    </div>
    <!-- warning -->
    <div class="symbol-alert-icon symbol-alert-warning scaleWarning" *ngIf="typeOfAlert === 'warning'">
      <span class="symbol-alert-body pulseWarningIns"></span>
      <span class="symbol-alert-dot pulseWarningIns"></span>
    </div>
    <!-- info -->
    <div class="symbol-alert-icon symbol-alert-info scaleWarning" *ngIf="typeOfAlert === 'info'">
      <span class="symbol-alert-dot pulseInfoIns"></span>
      <span class="symbol-alert-body pulseInfoIns"></span>
    </div>
    <!-- success -->
    <div class="symbol-alert-icon symbol-alert-success animate" *ngIf="typeOfAlert === 'success'">
      <span class="symbol-alert-line symbol-alert-tip animateSuccessTip"></span>
      <span class="symbol-alert-line symbol-alert-long animateSuccessLong"></span>
      <div class="symbol-alert-placeholder"></div>
      <div class="symbol-alert-fix"></div>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="pt-3 error-message text-center ">
    {{dataErr.message}}
  </div>
</div>

<div mat-dialog-actions class="pt-8 row">

  <div class="col-sm-8 offset-sm-2" *ngIf="!dataErr.decision">
    <button mat-raised-button class="btn btn-green btn-block" (click)="closeDialogError('close')">Aceptar</button>
  </div>

  <div class="col-sm-10 offset-sm-1" *ngIf="dataErr.decision">
    <div class="row">
      <div class="col-sm-6"> <button mat-raised-button class="btn btn-white btn-block"
          (click)="closeDialogError('close')">Cancelar</button> </div>
      <div class="col-sm-6">

        <button mat-raised-button class="btn  btn-green btn-block" (click)="closeDialogError(
        dataErr.wsName == 'loginwb05' ? 'closeSession' : data.codeError)">Aceptar</button>
      </div>
    </div>
  </div>
</div>